import { render, staticRenderFns } from "./SubStages.vue?vue&type=template&id=aec4a44e"
import script from "./SubStages.vue?vue&type=script&lang=js"
export * from "./SubStages.vue?vue&type=script&lang=js"
import style0 from "./SubStages.vue?vue&type=style&index=0&id=aec4a44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports